// extracted by mini-css-extract-plugin
export default {"SectionHeadline":"SectionHeadline_SectionHeadline__xa0oJ"};